import React from "react";
import { CircularProgress } from "@material-ui/core";
import "./Spinner.css";

const Spinner = () => {
  return (
    <div className="nmef-spinner-container">
      <CircularProgress size={35} color="secondary" />
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default Spinner;
